import React from "react";
import useIsMobile from "@/hooks/useIsMobile";

function Stat({ value, label, delay, isMobile }) {
  return (
    <div className="lf-fade-up" style={{ animationDelay: delay }}>
      <div style={{ font: `var(--fw-semibold) ${isMobile ? 20 : 26}px/1 var(--font-mono)`, color: "#fff" }}>{value}</div>
      <div style={{ marginTop: 6, font: "var(--fw-semibold) 11px/1 var(--font-sans)", letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--lf-blue-200)" }}>{label}</div>
    </div>
  );
}

export default function Hero({ stats }) {
  const isMobile = useIsMobile();
  const count = stats && stats.skus_live != null ? stats.skus_live : 5;
  return (
    <section style={{ padding: isMobile ? "26px 16px 24px" : "44px 32px 40px", background: "var(--lf-blue-900)", backgroundImage: "var(--texture-weave-light)", color: "var(--text-on-dark)" }}>
      <div style={{ maxWidth: 1320, margin: "0 auto", display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? "stretch" : "flex-end", justifyContent: "space-between", gap: isMobile ? 22 : 40, flexWrap: "wrap" }}>
        <div style={{ maxWidth: 620 }}>
          <span className="lf-fade-up" style={{ display: "block", font: "var(--fw-semibold) 11px/1 var(--font-sans)", letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--lf-blue-200)", marginBottom: 14 }}>
            Ready to ship · In stock
          </span>
          <h1 className="lf-fade-up" style={{ margin: 0, font: `var(--fw-semibold) ${isMobile ? 27 : 40}px/1.15 var(--font-display)`, letterSpacing: "-0.02em", color: "#fff", animationDelay: "60ms" }}>
            Denim styles you can order today
          </h1>
          <p className="lf-fade-up" style={{ margin: "12px 0 0", font: `var(--fw-regular) ${isMobile ? 14 : 15}px/1.6 var(--font-sans)`, color: "var(--lf-blue-100)", maxWidth: "52ch", animationDelay: "120ms" }}>
            Browse {count} ready-made styles with price and MOQ shown upfront. Pick a fit, request a sample, and place your order — no back-and-forth needed. Need a custom spec instead? Talk to us.
          </p>
        </div>
        <div style={{ display: "flex", gap: isMobile ? 28 : 36, flexWrap: "wrap" }}>
          <Stat value={stats ? stats.skus_live : "—"} label="SKUs live" delay="140ms" isMobile={isMobile} />
          <Stat value={stats ? stats.lowest_moq : "—"} label="Lowest MOQ" delay="200ms" isMobile={isMobile} />
          <Stat value={stats ? stats.lead_time : "—"} label="Lead time" delay="260ms" isMobile={isMobile} />
        </div>
      </div>
    </section>
  );
}
